import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AccessGateScreen } from "./../AccessGateScreen";

export const NoOrganizationScreen: FC = () => {
  const { t } = useTranslation();
  return (
    <AccessGateScreen
      title={t("auth.noOrganization.title")}
      text={t("auth.noOrganization.text")}
    />
  );
};
